import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart, FiShield, FiInfo, FiMail } = FiIcons;

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3, duration: 0.5 }}
      className="footer-bg mt-16"
    >
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center space-x-4 mb-6 md:mb-0">
            <div className="clay-button-pink p-3">
              <SafeIcon icon={FiHeart} className="text-2xl heart-logo" />
            </div>
            <div>
              <h3 className="text-xl font-bold gradient-text">Nakamoto Verse</h3>
              <p className="text-text font-medium">Spreading kindness, one message at a time</p>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 text-text font-bold">
            <Link
              to="/about"
              className="flex items-center space-x-2 hover:transform hover:scale-105 transition-all duration-300 clay-button-yellow px-4 py-2 rounded-full"
            >
              <SafeIcon icon={FiInfo} className="text-sm text-text" />
              <span>About</span>
            </Link>

            <Link
              to="/contact"
              className="flex items-center space-x-2 hover:transform hover:scale-105 transition-all duration-300 clay-button-green px-4 py-2 rounded-full"
            >
              <SafeIcon icon={FiMail} className="text-sm text-text" />
              <span>Contact</span>
            </Link>

            <Link
              to="/admin"
              className="flex items-center space-x-2 hover:transform hover:scale-105 transition-all duration-300 clay-button-purple px-4 py-2 rounded-full"
            >
              <SafeIcon icon={FiShield} className="text-sm text-text" />
              <span>Admin</span>
            </Link>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-purple/30 text-center">
          <p className="text-text font-bold">
            © 2025 Nakamoto Verse Platform
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;